import React, { useEffect, useState } from 'react';
import { ICountryPaxCount } from '../../type/countryPaxCount';
import { translate } from '../../i18n';
import Loader from '../../assets/loader/Loader';
import { useCountriesPaxDetails } from '../../hooks/apiHook/operationDetails';
import PaxPercentageBarSection from './PaxPercentageBarSection'; // Import the component

interface CountryPaxSectionProps {
  selectedDate: Date;
  ownerId: number;
}

const CountryPaxSection: React.FC<CountryPaxSectionProps> = ({
  selectedDate,
  ownerId,
}) => {
  const [selected, setSelected] = useState<ICountryPaxCount>();
  const [countryPaxCount, setCountryPaxCount] = useState<ICountryPaxCount[]>();

  const {
    data: countryPaxData,
    isLoading: isPaxLoading,
    refetch: refetchCountriesPax,
  } = useCountriesPaxDetails(selectedDate, ownerId);

  useEffect(() => {
    if (countryPaxData) {
      setCountryPaxCount(countryPaxData);
      setSelected(countryPaxData[0] || null);
    }
  }, [countryPaxData]);

  console.log(countryPaxData,'countryPaxData')

  return isPaxLoading ? (
    <div className="flex justify-center mb-5">
      <Loader width={50} height={50} />
    </div>
  ) : countryPaxCount?.length === 0 ? (
    <div>
      <p className="text-center content-center p-4 h-[100px] text-lg font-semibold text-text-primary">
        {translate('flightAllocation.noData')}
      </p>
    </div>
  ) : (
    <div className={'flex flex-col p-4 rounded-lg pt-6'}>
      {/* Flags Section */}
      <div className="flex mb-4">
        {countryPaxCount?.map((flag) => {
          return (
            <button
              key={flag?.name}
              onClick={() => setSelected(flag)}
              className="p-1 mr-4 transition-all"
            >
              {!flag?.flagUrl || flag?.name === 'Please Select' ? (
                <img className="w-12 h-12" src="/flag_generic.png" />
              ) : (
                <img
                  src={flag.flagUrl}
                  alt={flag.name}
                  className={`w-12 h-8 object-cover rounded border border-light-gray ${
                    selected?.name === flag?.name
                      ? 'shadow duration-150 transform scale-130'
                      : ''
                  }`}
                />
              )}
              {selected?.name === flag?.name && (
                <span className="text-xs text-text-primary">{flag?.name}</span>
              )}
            </button>
          );
        })}
      </div>
      {selected && (
        <div className="">
          <PaxPercentageBarSection
            allocatedPax={selected.paxCounts?.total || 0}
            capacity={countryPaxCount?.reduce((sum, country) => sum + (country.paxCounts?.total || 0), 0) || 0}
            className="text-end"
          />
        </div>
      )}

      {/* Stats Grid */}
      <div className="grid grid-cols-4 gap-4 sm:gap-8 text-center text-sm">
        <div className="bg-backgroundColor-darkThemeColor p-2 rounded">
          <div className="text-text-lightGray">
            {translate('operation.countryPaxCount.adult')}
          </div>
          <div className="text-lg text-text-lightGray">
            {selected?.paxCounts?.adult}
          </div>
        </div>
        <div className="bg-backgroundColor-darkThemeColor p-2 rounded">
          <div className="text-text-lightGray">
            {translate('operation.countryPaxCount.child')}
          </div>
          <div className="text-lg text-text-lightGray">
            {selected?.paxCounts?.child}
          </div>
        </div>
        <div className="bg-backgroundColor-darkThemeColor p-2 rounded">
          <div className="text-text-lightGray">
            {translate('operation.countryPaxCount.infant')}
          </div>
          <div className="text-lg text-text-lightGray">
            {selected?.paxCounts?.infant}
          </div>
        </div>
        <div className="bg-backgroundColor-darkThemeColor p-2 rounded">
          <div className="text-text-primary">{translate('operation.pax')}</div>
          <div className="text-lg text-text-lightGray">
            {selected?.paxCounts?.total}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryPaxSection;